import {observer} from "mobx-react-lite";
import React from "react";
import {Modulator} from "../stores/Modulator";
import {WAVEFORM_SAMPLEHOLD_NAME} from "../waveforms";

interface ModulatorCustomValuesProps {
    modulator: Modulator;           // "CC<CC>" by default
}

export const ModulatorCustomValues = observer(({modulator}: ModulatorCustomValuesProps) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        modulator.setCustomValues(e.currentTarget.value);
    }

    if (modulator.fName !== WAVEFORM_SAMPLEHOLD_NAME) return null;

    return (
        <div className="custom-values">
            <input type="search" value={modulator.customValues} placeholder={"random values"} onChange={e => handleChange(e)} />
        </div>
    );

});
